import React from "react";
import PathOption from "../PathOption";
import PathOptionGroup from "../PathOptionGroup";

function PathBuilderOptionsJavaCard({
  t,
  options,
  handleOptionChange,
  osSelected,
  productName,
  isSeedkeeperSelected,
}) {
  const cardReady =
    options.buyJavaCardReady ||
    options.flashJavaCardViaSeedSigner ||
    options.flashJavaCardDesktopDownload ||
    options.flashJavaCardDesktopCompile;

  return (
    <PathOptionGroup title={t("pathBuilder.categories.javacard")} className="javacard-multi-column">
      <div className="path-option-subgroup">
        <h4 className="path-option-subgroup-title">{t("pathBuilder.checkboxes.productSelection")}</h4>
        <div className="path-option-subgroup-options">
          <PathOption
            id="java-card-product-satochip"
            label={t("pathBuilder.checkboxes.satochip")}
            checked={options.javaCardProduct === "satochip"}
            onChange={() => handleOptionChange("javaCardProductSatochip")}
            disabled={!osSelected}
          />
          <PathOption
            id="java-card-product-seedkeeper"
            label={t("pathBuilder.checkboxes.seedkeeper")}
            checked={options.javaCardProduct === "seedkeeper"}
            onChange={() => handleOptionChange("javaCardProductSeedkeeper")}
            disabled={!osSelected}
          />
          <PathOption
            id="java-card-product-satodime"
            label={t("pathBuilder.checkboxes.satodime")}
            checked={options.javaCardProduct === "satodime"}
            onChange={() => handleOptionChange("javaCardProductSatodime")}
            disabled={!osSelected}
          />
        </div>
      </div>

      {options.javaCardProduct && (
        <div className="path-option-subgroup">
          <h4 className="path-option-subgroup-title">{t("pathBuilder.checkboxes.cardAcquisition")}</h4>
          <div className="path-option-subgroup-options">
            <PathOption
              id="buy-java-card-ready"
              label={t("pathBuilder.checkboxes.buyJavaCardReady", { product: productName })}
              checked={options.buyJavaCardReady}
              onChange={() => handleOptionChange("buyJavaCardReady")}
              disabled={!osSelected || !options.javaCardProduct || options.buyJavaCardBlank}
            />
            <PathOption
              id="buy-java-card-blank"
              label={t("pathBuilder.checkboxes.buyJavaCardBlank", { product: productName })}
              checked={options.buyJavaCardBlank}
              onChange={() => handleOptionChange("buyJavaCardBlank")}
              disabled={!osSelected || !options.javaCardProduct || options.buyJavaCardReady}
            />
          </div>
        </div>
      )}

      {options.javaCardProduct && options.buyJavaCardBlank && (
        <div className="path-option-subgroup">
          <h4 className="path-option-subgroup-title">{t("pathBuilder.checkboxes.flashingMethod")}</h4>
          <div className="path-option-subgroup-options">
            <PathOption
              id="flash-java-card-seedsigner"
              label={t("pathBuilder.checkboxes.flashViaSeedSigner")}
              checked={options.flashJavaCardViaSeedSigner}
              onChange={() => handleOptionChange("flashJavaCardViaSeedSigner")}
              disabled={
                !osSelected ||
                !options.javaCardProduct ||
                !options.buyJavaCardBlank ||
                options.flashJavaCardDesktopDownload ||
                options.flashJavaCardDesktopCompile
              }
            />
            <div>
              <PathOption
                id="flash-java-card-desktop"
                label={t("pathBuilder.checkboxes.flashViaDesktop")}
                checked={options.flashJavaCardDesktopDownload || options.flashJavaCardDesktopCompile}
                onChange={() => {
                  if (!options.flashJavaCardDesktopDownload && !options.flashJavaCardDesktopCompile) {
                    handleOptionChange("flashJavaCardDesktopDownload");
                  } else {
                    if (options.flashJavaCardDesktopDownload) handleOptionChange("flashJavaCardDesktopDownload");
                    if (options.flashJavaCardDesktopCompile) handleOptionChange("flashJavaCardDesktopCompile");
                  }
                }}
                disabled={
                  !osSelected ||
                  !options.javaCardProduct ||
                  !options.buyJavaCardBlank ||
                  options.flashJavaCardViaSeedSigner
                }
              />
              {(options.flashJavaCardDesktopDownload || options.flashJavaCardDesktopCompile) && (
                <div className="path-option-nested">
                  <div style={{ marginTop: "8px", marginBottom: "8px" }}>
                    <h5 style={{ fontSize: "0.9em", fontWeight: 600, color: "rgba(224, 224, 224, 0.9)", margin: "0 0 8px 0" }}>
                      {t("pathBuilder.checkboxes.acquireCapFile")}
                    </h5>
                  </div>
                  <div>
                    <PathOption
                      id="flash-java-card-desktop-download"
                      label={t("pathBuilder.checkboxes.useRelease")}
                      checked={options.flashJavaCardDesktopDownload}
                      onChange={() => handleOptionChange("flashJavaCardDesktopDownload")}
                      disabled={
                        !osSelected ||
                        !options.javaCardProduct ||
                        !options.buyJavaCardBlank ||
                        options.flashJavaCardViaSeedSigner ||
                        options.flashJavaCardDesktopCompile
                      }
                    />
                    <div className="path-option-nested">
                      <PathOption
                        id="verify-signature-java-card-desktop"
                        label={t("pathBuilder.checkboxes.verifySignature")}
                        checked={options.verifySignatureJavaCardDesktop}
                        onChange={() => handleOptionChange("verifySignatureJavaCardDesktop")}
                        disabled={!osSelected || !options.flashJavaCardDesktopDownload}
                      />
                    </div>
                  </div>
                  <PathOption
                    id="flash-java-card-desktop-compile"
                    label={t("pathBuilder.checkboxes.compile")}
                    checked={options.flashJavaCardDesktopCompile}
                    onChange={() => handleOptionChange("flashJavaCardDesktopCompile")}
                    disabled={
                      !osSelected ||
                      !options.javaCardProduct ||
                      !options.buyJavaCardBlank ||
                      options.flashJavaCardViaSeedSigner ||
                      options.flashJavaCardDesktopDownload
                    }
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {options.javaCardProduct && cardReady && (
        <>
          <PathOption
            id="add-remove-applet"
            label={t("pathBuilder.checkboxes.addRemoveApplet")}
            checked={options.addRemoveApplet}
            onChange={() => handleOptionChange("addRemoveApplet")}
            disabled={!osSelected || !options.javaCardProduct}
          />
          <PathOption
            id="remove-applet-via-seedsigner"
            label={t("pathBuilder.checkboxes.removeAppletViaSeedSigner")}
            checked={options.removeAppletViaSeedSigner}
            onChange={() => handleOptionChange("removeAppletViaSeedSigner")}
            disabled={!osSelected || !options.javaCardProduct}
          />
        </>
      )}

      {isSeedkeeperSelected && cardReady && (
        <>
          <PathOption
            id="create-seedkeeper"
            label={t("pathBuilder.checkboxes.createSeedkeeper")}
            checked={options.createSeedkeeper}
            onChange={() => handleOptionChange("createSeedkeeper")}
            disabled={!osSelected || !isSeedkeeperSelected}
          />
          <PathOption
            id="use-seedkeeper"
            label={t("pathBuilder.checkboxes.useSeedkeeper")}
            checked={options.useSeedkeeper}
            onChange={() => handleOptionChange("useSeedkeeper")}
            disabled={!osSelected || !isSeedkeeperSelected}
          />
          <PathOption
            id="backup-seedkeeper"
            label={t("pathBuilder.checkboxes.backupSeedkeeper")}
            checked={options.backupSeedkeeper}
            onChange={() => handleOptionChange("backupSeedkeeper")}
            disabled={!osSelected || !isSeedkeeperSelected}
          />
          <PathOption
            id="restore-from-seedkeeper"
            label={t("pathBuilder.checkboxes.restoreFromSeedkeeper")}
            checked={options.restoreFromSeedkeeper}
            onChange={() => handleOptionChange("restoreFromSeedkeeper")}
            disabled={!osSelected || !isSeedkeeperSelected}
          />
        </>
      )}
    </PathOptionGroup>
  );
}

export default PathBuilderOptionsJavaCard;
